import React, { Component } from 'react';
import {Col, Label, Input } from "reactstrap";

export default class InputFiltro extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            value: this.props.value ? this.props.value : ""
        };
    }
    

    handleChange = event => {
        if (this.props.type === "number" ) {
            if ( (/^[0-9]*$/g).test(event.target.value))
            {
                if(this.props.limiteMaximo){
                    if(event.target.value.length <= this.props.limiteMaximo){
                        this.setState({
                            value: event.target.value
                        })
                    }
                }else{
                    this.setState({
                        value: event.target.value
                    })
                }
            }
        }
        else {
            this.setState({
                value: event.target.value
            });
        }
        this.props.onChange(event, event);
    }

    handlePress = (event) => {
        if(event.key === 'Enter' && this.props.onEnter){
            this.props.onEnter()
        }
    }

    handleBlur = (event) => {
       if (this.props.onBlur) 
          this.props.onBlur(event, event);
    }

    render() {
        return(
            <Col className={this.props.className ? this.props.className : "mb-4 w-100"}
            xs={this.props.xs || 'auto'}
            sm={this.props.sm || 'auto'}
            md={this.props.md || 'auto'}
            lg={this.props.lg || 'auto'}
            xl={this.props.xl || 'auto'}
          >
                <div className="w-100">
                    <Col xs={12} className="col-label px-0">
                        <Label>{this.props.titulo}</Label>
                    </Col>
                    <Col xs={12} className="px-0">
                        <Input value={this.state.value}
                               className={this.props.uppercase ? 'input--uppercase' : ''} 
                               placeholder={this.props.placeholder ? this.props.placeholder : ""}
                               onKeyPress={this.handlePress}
                               type="text"
                               name={this.props.titulo} 
                               onChange={(event) => this.handleChange(event)}
                               onBlur={(event) => this.handleBlur(event)}
                               autoFocus={this.props.autoFocus}
                        />
                    </Col>
                    {this.props.alertaObrigatorio &&
                    <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>Esse campo é obrigatório</Label>
                    </Col>
                    }
                </div>
                
                
            </Col>
        )
    }

}



// WEBPACK FOOTER //
// ./src/modules/comum/components/InputFiltro.js